/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { cloneDeep, forEach, uniqBy } from "lodash";
import { isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getWorkHistoryCommuteAllList, getWorkRequestList } from "../../../apis/work-history";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import { classnames } from "../../../utils/text";
import { getPartAbsenteeList } from "../../../utils/work-schedule-calculator";
import AbsenteeModal from "./Component/AbsenteeModal";

const Worker = (props) => {
  const { parts } = useSelector(
    (store) => ({
      parts: store.Data.parts,
    }),
    shallowEqual
  );
  const [fields, setFields] = useState([]);
  const [filters, setFilters] = useState([])
  const [open, setOpen] = useState(false)
  const [absenteeData, setAbsenteeData] = useState({})
  const [resultRow, setResultRow] = useState({})
  const [partList, setPartList] = useState([])

  useEffect(() => {
    if (!isEmpty(parts))
    {
      setFilters([
        {
          title: "조회기간",
          type: "customdatepicker",
          key: "range",
        },
        {
          title: "부서",
          type: "select",
          key: "partIdxs",
          options: {
            list: [
              { label: "전체", value: "" },
              ...parts.map((part) => ({
                label: part.partName,
                value: part.idx,
              })),
            ]
          }
        },
      ])

      setPartList([
        ...parts,
        { idx: null, partName: '미지정' },
        { idx: 'total', partName: '합계' }
      ])
    }
  }, [parts])

  useEffect(() => {
    setFields([
      {
        title: "부서", key: "partIdx", onTranslator: {
          list: [
            { label: '미지정', value: null },
            ...partList.map((part) => ({
              label: part.partName,
              value: part.idx,
            }))]
        }
      },
      {
        title: "지각", key: "lateEmployees",
        onValue: (value, field, data) => {
          const _value = value || []
          const uniqEmployees = uniqBy(data.lateEmployees, 'employeeIdx')
          return (
            <a className={classnames('work-history-data', { 'color-main-100': !isEmpty(value) })} onClick={() => {
              if (isEmpty(value)) return;
              setAbsenteeData({
                partIdx: data.partIdx,
                type: 'isLate',
                ...data
              })
              setOpen(true)
            }}>{`${_value.length}건 / ${uniqEmployees.length}명`}</a>
          )
        }
      },
      {
        title: "조퇴", key: "earlyLeftEmployees",
        onValue: (value, field, data) => {
          const _value = value || []
          const uniqEmployees = uniqBy(data.earlyLeftEmployees, 'employeeIdx')
          return (
            <a className={classnames('work-history-data', { 'color-main-100': !isEmpty(value) })} onClick={() => {
              if (isEmpty(value)) return;
              setAbsenteeData({
                partIdx: data.partIdx,
                type: 'isEarlyLeft',
                ...data
              })
              setOpen(true)
            }}>{`${_value.length}건 / ${uniqEmployees.length}명`}</a>
          )
        }
      },
      {
        title: "근로 시간 미달", key: "shortWorkTimeEmployees",
        onValue: (value, field, data) => {
          const _value = value || []
          const uniqEmployees = uniqBy(data.shortWorkTimeEmployees, 'employeeIdx')
          return (
            <a className={classnames('work-history-data', { 'color-main-100': !isEmpty(value) })} onClick={() => {
              if (isEmpty(value)) return;
              setAbsenteeData({
                partIdx: data.partIdx,
                type: 'shortWork',
                ...data
              })
              setOpen(true)
            }}>{`${_value.length}건 / ${uniqEmployees.length}명`}</a>
          )
        }
      },
      {
        title: "연장 근무", key: "extendWorkTimeEmployees",
        onValue: (value, field, data) => {
          const _value = value || []
          const uniqEmployees = uniqBy(data.extendWorkTimeEmployees, 'employeeIdx')
          return (
            <a className={classnames('work-history-data', { 'color-main-100': !isEmpty(value) })} onClick={() => {
              if (isEmpty(value)) return;
              setAbsenteeData({
                partIdx: data.partIdx,
                type: 'extendWork',
                ...data
              })
              setOpen(true)
            }}>{`${_value.length}건 / ${uniqEmployees.length}명`}</a>
          )
        }
      },
      {
        title: "휴일 근무", key: "holidayWorkEmployees",
        onValue: (value, field, data) => {
          const _value = value || []
          const uniqEmployees = uniqBy(data.holidayWorkEmployees, 'employeeIdx')
          return (
            <a className={classnames('work-history-data', { 'color-main-100': !isEmpty(value) })} onClick={() => {
              if (isEmpty(value)) return;
              setAbsenteeData({
                partIdx: data.partIdx,
                type: 'holidayWork',
                ...data
              })
              setOpen(true)
            }}>{`${_value.length}건 / ${uniqEmployees.length}명`}</a>
          )
        }
      },
      {
        title: "변경 요청", key: "requestEmployees",
        onValue: (value, field, data) => {
          const _value = value || []
          const uniqEmployees = uniqBy(data.requestEmployees, 'employeeIdx')
          return (
            <a className={classnames('work-history-data', { 'color-main-100': !isEmpty(value) })} onClick={() => {
              if (isEmpty(value)) return;
              setAbsenteeData({
                partIdx: data.partIdx,
                type: 'request',
                ...data
              })
              setOpen(true)
            }}>{`${_value.length}건 / ${uniqEmployees.length}명`}</a>
          )
        }
      },
    ])
  }, [partList])

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
  } = useForm(
    {
      range: [getDay(7), getDay()]
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = async (params) => {
    setIsLoading(true)
    const _params = cloneDeep(params)
    const requestParams = {
      search: {
        type: 'history'
      },
      range: { createdTime: { from: params.range[0], to: params.range[1] } }
    }
    if (!isEmpty(_params.range))
    {
      _params.range = {
        startDate: _params.range[0],
        endDate: _params.range[1]
      }
    }
    if (!isEmpty(_params.partIdxs))
    {
      _params.search = {
        partIdxs: [Number(_params.partIdxs)]
      }

      requestParams.search = {
        ...requestParams.search,
        partIdxs: [Number(_params.partIdxs)]
      }
    }
    delete _params.partIdxs
    delete _params.page
    delete _params.limit

    try
    {
      const historyList = await getWorkHistoryCommuteAllList(_params)
      const requestList = await getWorkRequestList(requestParams)
      const partCommuteHistoryList = getPartAbsenteeList(historyList.data.data, requestList.data.requests)
      setList(partCommuteHistoryList)

      let result = {
        lateEmployees: [],
        earlyLeftEmployees: [],
        shortWorkTimeEmployees: [],
        extendWorkTimeEmployees: [],
        holidayWorkEmployees: [],
        requestEmployees: [],
      }
      if (!isEmpty(partCommuteHistoryList))
      {
        forEach(partCommuteHistoryList, (history) => {
          //console.log('history: ', history)

          result.lateEmployees.push(...history.lateEmployees)
          result.earlyLeftEmployees.push(...history.earlyLeftEmployees)
          result.shortWorkTimeEmployees.push(...history.shortWorkTimeEmployees)
          result.extendWorkTimeEmployees.push(...history.extendWorkTimeEmployees)
          result.holidayWorkEmployees.push(...history.holidayWorkEmployees)
          result.requestEmployees.push(...history.requestEmployees)
        })
      }
      setResultRow({
        partIdx: '합계',
        ...result
      })
    } catch (e)
    {

    } finally
    {
      setIsLoading(false)
    }
  };

  return (
    <div className="work-history-list-by-part">
      {!isEmpty(filters) && (
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
      )}
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        resultRow={resultRow}
      />
      <AbsenteeModal
        open={open}
        setOpen={setOpen}
        data={absenteeData}
        partList={partList}
      />
    </div>
  );
};

export default Worker;
